export const Know_More_Educator = {
  title:
    "Educators play a pivotal role in bridging academia and industry. At v18hub, you can seamlessly integrate real-world AI and data science projects into your students' learning journey with structured PO/CO alignment, built-in industry mentorship, and measurable outcomes that strengthen placement readiness and accreditation impact.",

  value_points: [
    {
      label: "Stronger placement outcomes",
      desc: "Students build resume-grade portfolios employers actually ask about.",
    },
    {
      label: "NAAC / accreditation narrative",
      desc: "Industry-integrated learning mapped to POs and COs across semesters.",
    },
    {
      label: "No curriculum overhaul needed",
      desc: "Programs run alongside existing academics, with exam break support.",
    },
    {
      label: "Applied research potential",
      desc: "Every cohort ends with open research topics, enabling student publications.",
    },
  ],

  how_does_it_work: [
    {
      inner_title: "Explore Programs",
      inner_desc:
        "Browse available programs and understand their structure, from Workshops and bootcamps for students new to AI, to advanced project cohorts covering GenAI, deep learning, and AI agents. Each cohort includes a clear semester-wise roadmap mapped to Program Outcomes (POs) and Course Outcomes (COs).",
      img: "/Images/explore_cohorts.png",
      img_alt: "Educator browsing AI and data science programs on v18hub",
    },
    {
      inner_title: "Register and Finalise Programs",
      inner_desc:
        "Register with us and select programs that best align with your students' semester and learning goals. We support workshops, bootcamps or a 4 to 7 semester structured program (Sem 1-7).",
      img: "/Images/select_cohorts.png",
      img_alt: "Educator selecting and finalising cohort programs for their students on v18hub",
    },
    {
      inner_title: "Onboard Your Students",
      inner_desc:
        "Register and connect your students to the chosen programs. Programs are designed around academic calendars with brief exam breaks built in. Faculty remain anchored in conceptual evaluation while industry mentors translate those concepts into real-world implementations aligned with current tools, workflows, and industry expectations.",
      img: "/Images/onboard.png",
      img_alt: "Educator onboarding engineering students into an industry-integrated AI cohort on v18hub",
    },
    {
      inner_title: "Empower Students, Track Outcomes",
      inner_desc:
        "Monitor student performance, track progress across cohorts, and stay updated on upcoming opportunities. Students document their work on GitHub, build strong project portfolios, and graduate with skills that translate directly into real-world execution and tech-ready performance in industry environments.",
      img: "/Images/empower_students.png",
      img_alt: "Educator tracking student progress and outcomes across AI cohorts on v18hub",
    },
  ],

  cta: [
    {
      button1: { label: "Explore Programs", href: "/programs" },
      // button2: { label: "Join as an Educator", href: "/registration/educator" },
    },
  ],
};
